import React, { useState, useEffect } from 'react'
import axios from 'axios'
/* Material UI */
import { makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, ButtonGroup, Button, IconButton } from '@material-ui/core'
import PlusIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import PdfIcon from '@material-ui/icons/PictureAsPdf'
/* Data */
import behaviorList from '../data/behavior_list.json'
import { initialRows } from '../data/initialState'
/* Styles */
import { styles } from '../styles/TableScreenStyle'

// Style
const useStyles = makeStyles(styles)

export default function TableScreens({ checkedItems }) {
  const classes = useStyles()
  const [rows, setRows] = useState([initialRows, initialRows, initialRows, initialRows, initialRows])

  const handleChange = (e, index) => {
    let name = e.target.name
    let value = e.target.value

    setRows(oldRows => (
      // 新しいオブジェクトを作って新しい配列に突っ込む
      oldRows.map((row, i) => i === index ? { ...row, [name]: value } : row)
    ))
  }

  // テーブル追加
  const addRow = () => setRows([...rows, initialRows])
  // テーブル削除
  const removeRow = () => setRows(rows.slice(0, -1))

  // テーブルデータ送信
  const sendData = () => {
    const json = JSON.stringify(rows)
    const url = `https://materials.strail-english.jp/behavior_trigger_preview?json=${json}`
    window.location.href = url
  }

  return (
    <>
      <TableContainer component={Paper} className={classes.root}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead className={classes.th}>
            <TableRow>
              <TableCell>どこ</TableCell>
              <TableCell>いつ</TableCell>
              <TableCell>〜したら</TableCell>
              <TableCell>〜する</TableCell>
              <TableCell>行動トリガー</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow className={classes.row}>
                <TableCell>
                  <input type="text" list="where" name="where" onChange={e => handleChange(e, index)} className={classes.input} />
                  <datalist id="where">
                    {behaviorList.where.map((item, index) => (
                      <option key={index} value={item} />
                    ))}
                  </datalist>
                </TableCell>
                <TableCell>
                  <input type="text" list="when" name="when" onChange={e => handleChange(e, index)} className={classes.input} />
                  <datalist id="when">
                    {behaviorList.when.map((item, index) => (
                      <option key={index} value={item} />
                    ))}
                  </datalist>
                </TableCell>
                <TableCell>
                  <input type="text" list="check_items" name="check_items" onChange={e => handleChange(e, index)} className={classes.input} />
                  <datalist id="check_items">
                    {checkedItems.map((item, index) => (
                      <option key={index} value={item} />
                    ))}
                  </datalist>
                </TableCell>
                <TableCell>
                  <input type="text" list="lack" name="lack" onChange={e => handleChange(e, index)} className={classes.input} />
                  <datalist id="lack">
                    {behaviorList.lack.map((item, index) => (
                      <option key={index} value={item} />
                    ))}
                  </datalist>
                </TableCell>
                <TableCell>
                  <input type="text" list="trigger" name="trigger" onChange={e => handleChange(e, index)} className={classes.input} />
                  <datalist id="trigger">
                    {behaviorList.trigger.map((item, index) => (
                      <option key={index} value={item} />
                    ))}
                  </datalist>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div className={classes.btnArea}>
        <ButtonGroup variant="contained">
          <IconButton color="primary" onClick={addRow} className={classes.btn}>
            <PlusIcon />
          </IconButton>
          <IconButton onClick={removeRow} className={classes.btn}>
            <RemoveIcon />
          </IconButton>
        </ButtonGroup>
        <Button variant="contained" color="primary" onClick={sendData} startIcon={<PdfIcon />}>
          プレビュー
        </Button>
      </div>
    </>
  )
}